import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=11eff011&scoped=true&"
import script from "./ButtonAction.vue?vue&type=script&lang=js&"
export * from "./ButtonAction.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAction.vue?vue&type=style&index=0&id=11eff011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../apps/shop/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eff011",
  null
  
)

export default component.exports